import { IconAndText } from "client/Components";
import { NumberFormatter } from "client/Hooks";
import { resolveFormattedTextString } from "client/Misc/utils";
import { localize } from "client_legacy/ndaw/culture";
import { ReactElement } from "react";
import { useHubStatisticsFormatter } from "../useHubStatisticsFormatter";

export type MemberStatisticProps = {
	membersCount: number;
	onClick?: () => void;
};

export const MemberStatistic = (props: MemberStatisticProps): ReactElement => {
	const {
		membersCount,
		onClick
	} = props;

	const formatNumber: NumberFormatter = useHubStatisticsFormatter();

	const text: string = membersCount === 1
		? localize("_1Member")
		: resolveFormattedTextString({
			template: localize("_AmountMembers"),
			replacements: [{
				what: "{{Amount}}",
				filler: formatNumber(membersCount)
			}]
		});

	return (
		<IconAndText
			text={text}
			trackingId="members-count"
			onClick={onClick}
		>
			<IconAndText.Icon
				value={{
					kind: "font",
					name: "user-group",
					color: "primary"
				}}
			/>
		</IconAndText>
	);
};
MemberStatistic.displayName = "MemberStatistic";
